import {
  Card,
  Row,
  Col,
  Button,
  Modal,
  Image,
  Carousel,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { imgUrl } from '../../Helpers/Constant';
import { FaLink, FaMoneyBillWave, FaRegBuilding } from 'react-icons/fa';
import {
  MdOutlineArrowBackIosNew,
  MdOutlineArrowForwardIos,
  MdOutlineCategory,
} from 'react-icons/md';
import { IProduct } from '../../Types/ProductTypes';
import { IWishList } from '../Visitor/apiEndpoints/visitorType';
import { TPublicProductAndServiceList } from './apiEndpoints/pubAndSerTypes';

type IProps = {
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  show: boolean;
  data: TPublicProductAndServiceList | IProduct | IWishList | undefined;
};
const ProductDetailsWithModal = ({ setShow, show, data }: IProps) => {
  const handleClose = () => setShow(false);
  return (
    <div>
      <Modal show={show} onHide={handleClose} size='xl'>
        <Modal.Body>
          <Card className='position-relative shadow'>
            <Row className='g-0'>
              <Col xs={12} md={4}>
                <div
                  className='p-3'
                  style={{ background: 'grlay', height: '100%' }}
                >
                  <Carousel
                    prevIcon={<MdOutlineArrowBackIosNew color='red' />}
                    nextIcon={<MdOutlineArrowForwardIos color='red' />}
                    style={{
                      textAlign: 'center',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    variant='dark'
                    indicators={false}
                  >
                    {data?.fair_member_product_photo &&
                      Array.isArray(data.fair_member_product_photo) &&
                      data.fair_member_product_photo?.map((item) => (
                        <Carousel.Item
                          key={item}
                          interval={1000}
                          style={{ textAlign: 'center', height: '100%' }}
                        >
                          {data?.fair_member_product_photo &&
                            Array.isArray(data.fair_member_product_photo) && (
                              <>
                                <Image
                                  src={imgUrl + '/' + item}
                                  alt={data?.fair_member_product_photo[0]}
                                  // height={230}
                                  height={'auto'}
                                  style={{ maxWidth: '210px' }}
                                  className='object-fit-cover'
                                />
                              </>
                            )}
                        </Carousel.Item>
                      ))}
                  </Carousel>
                </div>
              </Col>

              <Col xs={12} md={8}>
                <Card.Body>
                  <div className='d-flex justify-content-between align-items-start'>
                    <h2 className='text-primary fw-bold'>
                      {data?.fair_member_product_name}
                    </h2>
                  </div>

                  <Row className='mb-2'>
                    <Col xs={12} className='text-secondary'>
                      <FaRegBuilding color='gray' size={20} />
                      <span className='text-secondary'>Company : </span>
                      <span className='text-primary'>
                        {data?.user_fair_member_company_name}
                      </span>
                    </Col>
                    <Col xs={12}>
                      <MdOutlineCategory color='gray' size={20} />{' '}
                      <span className='text-secondary'>Category : </span>
                      <span className='text-secondary'>
                        {data?.fair_member_product_category}
                      </span>
                    </Col>
                    <Col xs={12}>
                      <span className='text-secondary'>
                        <FaMoneyBillWave color='gray' size={20} /> Price :{' '}
                      </span>
                      <span className='text-secondary'>
                        {`${data?.fair_member_product_price} - ${data?.fair_member_special_product_price}
            `}
                      </span>
                    </Col>
                  </Row>

                  <Row className='mb-2'>
                    <Col xs={12}>
                      <span className='text-secondary'>
                        <FaLink color='gray' size={18} /> Link :{' '}
                      </span>
                      <Link
                        to={`/product-services/exhibitor/details/${data?.exhibitor_id}`}
                        className='text-primary text-decoration-none'
                      >
                        {data?.fair_member_product_url}
                      </Link>
                    </Col>
                  </Row>

                  <hr />

                  <div className='mt-3'>
                    <h5 className='fw-bold'>Description</h5>
                    <p className='small text-secondary'>
                      {data?.fair_member_product_description}
                    </p>
                  </div>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </Modal.Body>

        <Modal.Footer>
          <Button variant='primary' onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ProductDetailsWithModal;
